// Module
var code = `<div>
  <table class="table">
    <thead>
    <tr>
      <td colspan="2">
        Category
      </td>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="group in \$ctrl.commandGroups">
      <td class="group">{{group}}</td>
      <td class="action">
        <button type="button"
                class="btn btn-primary"
                ng-click="\$ctrl.openGroup(group)">
          Open
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/role-write-access-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;